import React from 'react';

function Contact() {
  return (
    <section id="contact">
      <h2 className="contact-head reveal">LET'S MAKE<br />IT<span>HAPPEN.</span></h2>
      <p className="contact-sub reveal d1">For bookings and inquiries</p>
      <a href="mailto:abhinavsreekumarofficial@gmail.com" className="contact-email reveal d2 magnetic">abhinavsreekumarofficial@gmail.com</a>
    </section>
  );
}

export default Contact;
